import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field, FieldArray } from 'redux-form';
import { I18n, Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import { TriggerValidations } from '../../../models';
import { TRIGGER_OPTIONS } from '../../../constants/triggers';
import styles from './AddTriggerForm.styles';

import AddCriteriaForm from './addcriteriaform/AddCriteriaForm';
import Button from '../../inputs/button/Button';
import AddForm from '../addform/AddForm';
import FormActions from '../formactions/FormActions';
import FormField from '../formfield/FormField';

const loadOption = option => ({
  label: I18n.t(option.label),
  value: option.value
});

export class AddTriggerForm extends Component {
  typeOptions = Object.values(TRIGGER_OPTIONS).map(loadOption);
  render() {
    const isEditingCriteria =
      this.props.criteria && this.props.criteria.find(crit => crit.isEditing);
    return (
      <AddForm onSubmit={this.props.handleSubmit} styles={styles.form}>
        <span className={css(styles.label)}>
          <Translate value="models.trigger.type" />:
        </span>
        <Field
          name="type"
          type="custom-radio"
          component={FormField}
          options={this.typeOptions}
          validate={TriggerValidations.type}
        />
        <FieldArray
          name="criteria"
          component={AddCriteriaForm}
          criteria={this.props.criteria}
          change={this.props.change}
          sites={this.props.sites}
          areas={this.props.areas}
          zones={this.props.zones}
          locations={this.props.locations}
          categories={this.props.categories}
          groups={this.props.groups}
        />
        <FormActions>
          <Button disabled={isEditingCriteria}>
            <Translate value="save" />
          </Button>
          <Button
            styles={styles.flatButton}
            type="button"
            onClick={this.props.onCancel}
          >
            <Translate value="cancel" />
          </Button>
        </FormActions>
      </AddForm>
    );
  }
}

const selector = formValueSelector('addTrigger');
const mapStateToProps = state => {
  const {
    sites: { list: sites },
    areas: { list: areas },
    zones: { list: zones },
    locations: { list: locations },
    categories: { list: categories },
    groups: { list: groups }
  } = state;
  return {
    criteria: selector(state, 'criteria'),
    sites,
    areas,
    zones,
    locations,
    categories,
    groups
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addTrigger'
  })(AddTriggerForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/addtriggerform/AddTriggerForm.js